import React from 'react';
import YacheikiUslugiBlock from '../../components/YacheikiUslugiBlock'
import PageLayout from '../../components/PageLayout';

export default function FederationadministratorComissionServices(props) {
    return (<PageLayout>
        <YacheikiUslugiBlock {...props} source={"/api/yacheikiuslugi/list/fed"}
        queryDetail="model"
                sourceKey="fed"
                create={true}
                ctx={{organizatorFederatsiyaID: 1}}
                // context={{
                //     mix: (item) => {
                //         return {
                //             organizatorFederatsiyaID: 1, // Организатор федерация
                //         }
                //     }
                // }}
            />
    </PageLayout>);
}
